import { Metadata } from '@redwoodjs/web';
import { useParams } from '@tanstack/react-router';
import WarehousePage from './page/WarehousePage';

/** The route entry: reads the id and keeps the page's one Redwood edge (`Metadata`) out of the new files. */
export default function WarehouseDetailsPage() {
  const { warehouseId } = useParams({ from: '/agriful-frame/settings/inventory/warehouses/$warehouseId' });

  return (
    <WarehousePage
      warehouseId={warehouseId}
      metadata={(warehouseName) => <Metadata title={`${warehouseName} - Warehouse Details`} />}
    />
  );
}
